export default "__VITE_PUBLIC_ASSET__aebc2ce5__"